import { render } from "./ResultSportMvB.vue?vue&type=template&id=7f751f4c&scoped=true"
const script = {}

import "./ResultSportMvB.vue?vue&type=style&index=0&id=7f751f4c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7f751f4c"

export default script